import { networkBus } from '@tunasong/models'
import { useEffect, useState } from 'react'

/** Changes waiting to sync: queued uploads plus queued mutations, from the network bus. */
export const usePendingChangesCount = () => {
  const [uploads, setUploads] = useState(0)
  const [mutations, setMutations] = useState(0)

  useEffect(() => {
    const offUploads = networkBus.on('uploads-changed', payload => setUploads(payload.count))
    const offMutations = networkBus.on('mutations-changed', payload => setMutations(payload.count))
    return () => {
      offUploads()
      offMutations()
    }
  }, [])

  return uploads + mutations
}

export const getSyncStatusText = (pending: number) =>
  pending === 0 ? 'All changes synced' : `${pending} ${pending === 1 ? 'change' : 'changes'} waiting to sync`
